import { useUserPermissions } from "../../SignIn/UserPermissionsContext";

// const toPermissionValues = (userPermissions) => {
//   const source = Array.isArray(userPermissions)
//     ? userPermissions
//     : Array.isArray(userPermissions?.permissions)
//       ? userPermissions.permissions
//       : [];

//   return source
//     .map((permission) => {
//       if (typeof permission === "string") return permission;
//       if (typeof permission?.name === "string") return permission.name;
//       if (typeof permission?.value === "string") return permission.value;
//       return "";
//     })
//     .map((permission) => permission.trim().toLowerCase())
//     .filter(Boolean);
// };

// export const hasHolidayAdminPermission = (userPermissions) => {
//   const permissions = toPermissionValues(userPermissions);

//   return permissions.some((permission) => {
//     return permission === "holiday admin" || permission === "holiday_admin";
//   });
// };

const toPermissionValues = (userPermissions) => {
  const source = Array.isArray(userPermissions)
    ? userPermissions
    : Array.isArray(userPermissions?.permissions)
      ? userPermissions.permissions
      : [];

  return source
    .map((permission) => {
      if (typeof permission === "string") return permission;
      if (typeof permission?.name === "string") return permission.name;
      if (typeof permission?.value === "string") return permission.value;
      return "";
    })
    .map((permission) => permission.trim().toLowerCase())
    .filter(Boolean);
};

export const hasHolidayAdminPermission = (userPermissions) => {
  const permissions = toPermissionValues(userPermissions);

  return permissions.some(
    (permission) =>
      permission === "holiday admin" ||
      permission === "holiday_admin" ||
      permission === "super holiday admin",
  );
};

export const hasFinanceAdminPermission = (userPermissions) => {
  const permissions = toPermissionValues(userPermissions);

  return permissions.some(
    (permission) =>
      permission === "finance admin" ||
      permission === "finance_admin" ||
      permission === "administrator",
  );
};

export const hasStaffHolidayAccess = (userPermissions) => {
  return hasHolidayAdminPermission(userPermissions);
};